import React from 'react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';

const MySites = ({sites, editCallback, mySitesType}) => {

    const siteStatuses = [
        {
            id: 1,
            status: 'Creating',
            label: 'Creating'
        },
        {
            id: 2,
            status: 'PendingApproval',
            label: 'Pending Approval'
        },
        {
            id: 3,
            status: 'Active',
            label: 'Active'
        },
        {
            id: 4,
            status: 'Expired',
            label: 'Expired'
        },
        {
            id: 5,
            status: 'Disabled',
            label: 'Disabled'
        },
        {
            id: 6,
            status: 'Deleted',
            label: 'Deleted'
        },
        {
            id: 7,
            status: 'Canceled',
            label: 'Canceled'
        },
        {
            id: 8,
            status: 'Rejected',
            label: 'Rejected'
        },
        {
            id: 9,
            status: 'Archived',
            label: 'Archived'
        }
    ]

    const sitesToDisplay = siteStatuses.map(x=> 
        <TileGroup  
            key={x.id}
            groupBy={x.label} 
            elements={sites.filter(site => (site.siteStatus === x.status)).map(s =>
                <SingleSite
                    key={s.id}
                    site={s}
                    callBack={id => editCallback(id, mySitesType, 'Site')}
                />)}
        />)

    return(
        <div>
            {sitesToDisplay}
        </div>
    );
}

export default MySites


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MySites.js